jQuery(document).ready(function alphabetDocumentSelector($) {
    "use strict";

    var $container = $('.alphabet-document-selector');
    var $characters = $container.find('a');
    var $rows = $('.archive-message');

    var active_button = null;

    $characters.on('click', onToggleCharacter);

    markCharactersAsDisabled();

    function onToggleCharacter(e) {
        e.preventDefault();

        var $this = $(this);

        if(active_button != null) {
            $(active_button).removeClass('selected');
        }

        if(active_button != null && active_button === this) {
            for(var i = 0, l = $rows.length; i < l; ++i) {
                $($rows[i]).show();
            }

            active_button = null;

            return;
        }

        active_button = this;

        $(active_button).addClass('selected');

        var char = $this.attr('href')
            .substr(1, 2)
            .toLowerCase();

        for(var i = 0, l = $rows.length; i < l; ++i) {
            filterRowByCharacter(char, $($rows[i]));
        }
    }

    function filterRowByCharacter(char, $row) {
        var title = $row.find('.archive-message__title').text().trim();
        var first_char_in_title = title.substr(0, 1).toLowerCase();

        if(char === first_char_in_title) {
            $row.show();

            return;
        }

        $row.hide();
    }

    function markCharactersAsDisabled() {
        var first_characters_in_titles = getFirstCharacterOfTitles();

        for(var i = 0, l = $characters.length, $char, char; i < l; ++i) {
            $char = $($characters[i]);
            char = $char.attr('href').substr(1, 2);
            if(first_characters_in_titles.indexOf(char) === -1) {
                $char.attr('disabled', 'disabled');
            }
        }
    }

    function getFirstCharacterOfTitles() {
        var titles = [];
        for(var i = 0, l = $rows.length; i < l; ++i) {
            titles.push(
                $($rows[i]).find('.archive-message__title').text().trim().substr(0, 1)
            );
        }

        return titles;
    }
});